export default __webpack_public_path__ + "static/media/logo-stripe.5477692e.png";